const React = require('react');
const Input = require('./../../../FormComponents/Input');
const SelectComponent = require('./../../../FormComponents/Select');

const applicant = {
    firstName: null,
    lastName: null,
    identityNumber: null,
    email: null,
    phone: null,
    creditCheck: null,
    occupation: {value: null, label: null},
};

const occupationOptions = [
    { value: 'i-arbeid', label: 'I arbeid' },
    { value: 'student', label: 'Student' },
    { value: 'hjemmevaerende-med-barn', label: 'Hjemmeværende med barn' },
    { value: 'arbeidssoker', label: 'Arbeidssøker' },
    { value: 'pensjonist', label: 'Pensjonist' },
    { value: 'hjemmevaerende', label: 'Hjemmeværende' },
];

class Soker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {applicants: []};
        this.addApplicant = this.addApplicant.bind(this);
        this.removeApplicant = this.removeApplicant.bind(this);
        this.onChange = this.onChange.bind(this);
        this.setOccupation = this.setOccupation.bind(this);
    }
    removeApplicant(index) {
        const {applicants} = this.state;
        applicants.splice(index, 1);
        this.setState({applicants: applicants});
    }
    addApplicant() {
        this.setState({applicants: this.state.applicants.concat(Object.assign({}, applicant))});
    }
    getApplicants() {
        const {applicants} = this.state;
        return applicants;
    }
    onChange(ev, field, index) {
        const applicants = this.state.applicants.map((applicant, i) => {
            if (i === index) {
                applicant[field] = ev.target.value;
            }
            return applicant;
        });
        this.setState({applicants});
    }
    setOccupation(value, index) {
        const applicants = this.state.applicants.map((applicant, i) => {
            if (i === index) {
                applicant['occupation'] = value;
            }
            return applicant;
        });
        this.setState({applicants});
    }
    render() {
        const {color} = this.props;
        const {applicants} = this.state;
        const selectedOccupation = this.state.occupation && this.state.occupation.value;
        return (
            <div className={`sokere sokere--${color} ${this.props.className}`}>
                {applicants.map((applicant, i) => {
                    return (
                    <div className="sokere__container" key={i}>
                        <h3 className="sokere__header">
                            Medsøker {i+1}
                            <a className="sokere__removeApplicant" onClick={() => this.removeApplicant(i)}>Fjern</a>
                        </h3>
                        <div className="forms__formElement">
                            <Input name={'applicant['+i+'][firstName]'} required validations="minLength:1" type="text" onChange={(ev) => this.onChange(ev, 'firstName', i)} placeholder="Fornavn" />
                        </div>
                        <div className="forms__formElement">
                            <Input name={'applicant['+i+'][lastName]'} required type="text" validations="minLength:1" onChange={(ev) => this.onChange(ev, 'lastName', i)} placeholder="Etternavn" />
                        </div>
                        <div className="forms__formElement">
                            <Input name={'applicant['+i+'][email]'} required type="text" validations="isEmail" onChange={(ev) => this.onChange(ev, 'email', i)} placeholder="Epost" />
                        </div>
                        <div className="forms__formElement">
                            <Input name={'applicant['+i+'][phone]'} required type="text" validations="minLength:8" onChange={(ev) => this.onChange(ev, 'phone', i)} placeholder="Telefon" />
                        </div>
                        <div className="forms__formElement">
                            <SelectComponent name={'applicant['+i+'][occupation]'} validations="isExisty" value={selectedOccupation} onChange={(option) => this.setOccupation(option, i)} options={occupationOptions} className="react-select-custom" placeholder="Arbeid/Student"/>
                        </div>
                        <div className="forms__formElement">
                            <Input required name={'applicant['+i+'][identityNumber]'} pattern=".{11}" title="11 siffer" type="text" onChange={(ev) => this.onChange(ev, 'identityNumber', i)} placeholder="Fødselsnummer 11 siffer" validations="minLength:11" />
                        </div>
                        <div className="forms__formElement">
                            <label><input name={'applicant['+i+'][creditCheck]'} required type="checkbox" value={true} checked={applicant.creditCheck} onChange={ev => this.setState({creditCheck: ev.target.checked})}/> Jeg samtykker til kredittsjekk</label>
                        </div>
                    </div>
                    )
                })}
                <button className="sokere__addApplicant" type="button" onClick={this.addApplicant}>Legg til medsøker</button>
            </div>

        )
    }
}

module.exports = Soker;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/BoligSoknad/Soker/index.jsx